<script>
	import Button,{ Label } from '@smui/button';
	import Paper,{ Content,Subtitle,Title } from '@smui/paper';
	import Textfield from "@smui/textfield";
	import ValidationHelper from "../Helpers/ValidationHelper";
	import Spinner from "../UI/Spinner/Spinner.svelte";
	import SpinnerSize from "../UI/Spinner/SpinnerSize";
	import AuthConfig from './AuthConfig';
	import AuthChallenge from "./Enums/AuthChallenge";
	import AuthFlowType from './Enums/AuthFlowType';
	import AuthState from "./Enums/AuthState";
	import './LoginPanel.scss';
	import AuthStore from "./Store";
	
	const LoginPanelState = {
		LOGIN: "login",
		FORGOT_PASSWORD: "forgot_password"
	};

	const ForgotPasswordState = {
		NONE: "none",
		INPUT_USERNAME: "input_username",
		INPUT_CODE_AND_NEW_PASSWORD: "input_code_and_new_password"
	};

	let state = LoginPanelState.LOGIN;
	let forgotpwState = ForgotPasswordState.NONE;

	let authState = AuthStore.meta.state;
	let challengeType = AuthStore.meta.challenge.type;

	let loginUsername = AuthStore.forms.login.username;
	let loginPassword = AuthStore.forms.login.password;
	let loginError = AuthStore.forms.login.error;
	let loginSubmitting = AuthStore.forms.login.submitting;

	let forgotPasswordUsername = AuthStore.forms.forgotPassword.username;
	let forgotPasswordCode = AuthStore.forms.forgotPassword.code;
	let forgotPasswordNewPassword = AuthStore.forms.forgotPassword.newPassword;
	let forgotPasswordNewPasswordConfirm = AuthStore.forms.forgotPassword.newPasswordConfirm;
	let forgotPasswordError = AuthStore.forms.forgotPassword.error;
	let forgotPasswordSubmitting = AuthStore.forms.forgotPassword.submitting;
	let forgotPasswordSuccess = AuthStore.forms.forgotPassword.success;
	let forgotPasswordCodeDeliveryMethod = AuthStore.forms.forgotPassword.codeDelivery.method;
	let forgotPasswordCodeDeliveryDest = AuthStore.forms.forgotPassword.codeDelivery.destination;

	$: {
		if ($authState == AuthState.LOGGING_IN_CHALLENGE) {
			$loginPassword = "";
		}
	}

	let style = "width:100%;margin-top:10px;";
	let errorStyle = "width:calc(100% - 20px);margin-top:10px;padding:10px;border-radius:3px;";
	let spinnerStyle = "width:calc(100% - 40px);padding:20px;text-align:center;";

	let resetLoginError = () => {
		$loginError = "";
	};
	let onLoginSubmit = (e) => {
		e.preventDefault();
		$loginUsername = $loginUsername.trim();
		AuthStore.actions.login($loginUsername, $loginPassword);
	};
	let onLoginNewPasswordValidate = () => {
		$loginError = "";
		let errs = ValidationHelper.validateNewPassword($loginPassword);
		if (errs.length > 0) {
			$loginError = errs.join("<br/>");
		}
		return ($loginError.length == 0);
	}
	let onLoginNewPasswordSubmit = (e) => {
		e.preventDefault();
		if (!onLoginNewPasswordValidate()) {
			return;
		}
		AuthStore.actions.setNewPassword($loginUsername, $loginPassword);
	}

	let resetForgotPasswordError = () => {
		$forgotPasswordError = "";
	};
	let onForgotPassword = () => {
		state = LoginPanelState.FORGOT_PASSWORD;
		forgotpwState = ForgotPasswordState.INPUT_USERNAME;
		$forgotPasswordUsername = $loginUsername;
	};
	let onForgotPasswordBack = () => {
		state = LoginPanelState.LOGIN;
	};
	let onForgotPasswordSubmit = (e) => {
		e.preventDefault();

		$forgotPasswordSubmitting = true;
		$forgotPasswordError = "";
		AuthStore.actions.forgotPassword($forgotPasswordUsername)
			.then((response) => {
				forgotpwState = ForgotPasswordState.INPUT_CODE_AND_NEW_PASSWORD;

				AuthStore.forms.forgotPassword.codeDelivery.method.set(response.data.CodeDeliveryDetails.AttributeName);
				AuthStore.forms.forgotPassword.codeDelivery.destination.set(response.data.CodeDeliveryDetails.Destination);

			})
			.catch((error) => {
				$forgotPasswordError = error.message;
			})
			.finally(() => {
				$forgotPasswordSubmitting = false;
			});
	}
	let onForgotPasswordHaveCode = (e) => {
		e.preventDefault();
		$forgotPasswordError = "";
		forgotpwState = ForgotPasswordState.INPUT_CODE_AND_NEW_PASSWORD;
		AuthStore.forms.forgotPassword.codeDelivery.method.set("");
		AuthStore.forms.forgotPassword.codeDelivery.destination.set("");
	}
	// Returns true on validation passed, false on errors.
	let onForgotPasswordConfirmValidate = () => {
		$forgotPasswordError = "";
		let errs = []
		if ($forgotPasswordCode.length == 0) {
			errs.push("Code must not be left blank.");
		}
		errs = [...ValidationHelper.validateNewPassword($forgotPasswordNewPassword)];
		if ($forgotPasswordNewPassword != $forgotPasswordNewPasswordConfirm) {
			errs.push("Password entered must match.");
		}
		if (errs.length > 0) {
			$forgotPasswordError = errs.join("<br/>");
		}
		return ($forgotPasswordError.length == 0);
	}
	let onForgotPasswordConfirmSubmit = (e) => {
		e.preventDefault();
		if (!onForgotPasswordConfirmValidate()) {
			return;
		}
		$forgotPasswordSubmitting = true;
		AuthStore.actions.forgotPasswordConfirm($forgotPasswordUsername, $forgotPasswordCode, $forgotPasswordNewPassword)
			.then((response) => {
				// redirect to login form.
				$forgotPasswordSuccess = true;
				$authState = AuthState.LOGGED_OUT;
				state = LoginPanelState.LOGIN;
			})
			.catch((error) => {
				$forgotPasswordError = error.message;
			})
			.finally(() => {
				$forgotPasswordSubmitting = false;
			});
	}


	let onOAuthLoginStart = () => {
		window.location = AuthConfig.loginUrl;
	}

</script>


	
		<Paper color={"surface"} elevation={10} >
			<Title>Geonius</Title>
			<!-- <Title>Login</Title> -->
			<!-- <Subtitle>The Geospatial Intelligence Platform</Subtitle> -->
			<Content>

				{#if AuthConfig.authFlowType === AuthFlowType.OAUTH}

					{#if $authState === AuthState.LOGGED_OUT}
						<Subtitle>You will need to login.</Subtitle>
						<Button type="submit" variant="unelevated" on:click={onOAuthLoginStart} style={style}>
							<Label>Login</Label>
						</Button>
					{:else if $authState === AuthState.LOGGING_IN}
						<Subtitle>Logging in...</Subtitle>
						<div style={spinnerStyle}>
							<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
						</div>
					{:else if $authState === AuthState.LOGGING_OUT}
						<Subtitle>Logging out...</Subtitle>
						<div style={spinnerStyle}>
							<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
						</div>
					{/if}

				{:else if AuthConfig.authFlowType === AuthFlowType.USER_PASSWORD_AUTH}

					{#if $authState === AuthState.LOGGED_OUT}

						{#if state === LoginPanelState.LOGIN}

							<Subtitle>You will need to login.</Subtitle>
							<form id="login-form" name="login-form" url="/" autocomplete="on" on:submit={onLoginSubmit}>

								{#if $forgotPasswordSuccess}
									<div class="bg-success" style={errorStyle}>Password reset successful. You may now login.</div>
								{/if}

								<Textfield type="text" dense variant={"filled"} bind:value={$loginUsername}  input$autocomplete="on" label="Username" style={style} on:input={resetLoginError} />

								<Textfield type="password" dense variant={"filled"} bind:value={$loginPassword}  input$autocomplete="off" label="Password" style={style} on:input={resetLoginError} />

								{#if $loginError.length > 0}
									<div class="bg-error" style={errorStyle}>{@html $loginError}</div>
								{/if}

								{#if $loginSubmitting}
									<Button variant="unelevated" style={style} disabled={true}>
										<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
									</Button>
								{:else}
									<Button type="submit" variant="unelevated" on:click={onLoginSubmit} style={style} disabled={$loginError.length > 0 || $loginUsername.length == 0 || $loginPassword.length == 0}>
										<Label>Login</Label>
									</Button>
								{/if}

								<Button variant="unelevated" color="secondary" on:click={onForgotPassword} style={style} >
									<Label>Forgot Password?</Label>
								</Button>

							</form>
						{:else if state === LoginPanelState.FORGOT_PASSWORD}

							{#if forgotpwState === ForgotPasswordState.INPUT_USERNAME}

								<Subtitle>Forgot your password?</Subtitle>
								<p>Enter your Username below and we will send a message/code to reset your password.</p>

								<form id="forgotpw-form" name="forgotpw-form" url="/" autocomplete="on" on:submit={onForgotPasswordSubmit}>
									<Textfield type="text" dense variant={"filled"} bind:value={$forgotPasswordUsername}  input$autocomplete="on" label="Username" style={style} on:input={resetForgotPasswordError}/>

									{#if $forgotPasswordError.length > 0}
										<div class="bg-error" style={errorStyle}>{@html $forgotPasswordError}</div>
									{/if}

									{#if $forgotPasswordSubmitting}
										<Button variant="unelevated" style={style} disabled={true}>
											<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
										</Button>
									{:else}
										<Button type="submit" variant="unelevated" on:click={onForgotPasswordSubmit} style={style} disabled={$forgotPasswordError.length > 0 || $forgotPasswordUsername.length == 0}>
											<Label>Reset my password</Label>
										</Button>
										<Button type="submit" variant="unelevated" class="bg-info" on:click={onForgotPasswordHaveCode} style={style}><Label>I already have a code!</Label></Button>
									{/if}

									<Button variant="unelevated" color="secondary" on:click={onForgotPasswordBack} style={style}>
										<Label>Back</Label>
									</Button>
								</form>

							{:else if forgotpwState === ForgotPasswordState.INPUT_CODE_AND_NEW_PASSWORD}

								<Subtitle>Reset Password</Subtitle>
								{#if $forgotPasswordCodeDeliveryMethod.length > 0}
									<p>We have sent a password reset code by {$forgotPasswordCodeDeliveryMethod} to {$forgotPasswordCodeDeliveryDest}. Enter it below to reset your password.</p>
								{:else}
									<p>You have received a password reset code by email or sms. Enter it below to reset your password.</p>
								{/if}

								<form id="forgotpw-confirm-form" name="forgotpw-confirm-form" url="/" autocomplete="off" on:submit={onForgotPasswordConfirmSubmit}>

									<Textfield type="text" dense variant={"filled"} bind:value={$forgotPasswordCode} input$autocomplete="off" label="Code" style={style} on:keyup={onForgotPasswordConfirmValidate} />

									<Textfield type="password" dense variant={"filled"} bind:value={$forgotPasswordNewPassword} input$autocomplete="off" label="New Password" style={style} on:keyup={onForgotPasswordConfirmValidate} />

									<Textfield type="password" dense variant={"filled"} bind:value={$forgotPasswordNewPasswordConfirm} input$autocomplete="off" label="Confirm New Password" style={style} on:keyup={onForgotPasswordConfirmValidate} />

									{#if $forgotPasswordError.length > 0}
										<div class="bg-error" style={errorStyle}>{@html $forgotPasswordError}</div>
									{/if}

									{#if $forgotPasswordSubmitting}
										<Button variant="unelevated" style={style} disabled={true}>
											<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
										</Button>
									{:else}
										<Button type="submit" variant="unelevated" on:click={onForgotPasswordConfirmSubmit} style={style} disabled={$forgotPasswordError.length > 0 || $forgotPasswordCode.length == 0 || $forgotPasswordNewPassword.length == 0 || $forgotPasswordNewPasswordConfirm.length == 0}>
											<Label>Change Password</Label>
										</Button>
									{/if}
								</form>

							{/if}

						{/if}

					{:else if $authState === AuthState.LOGGING_IN}

						<Subtitle>Logging in...</Subtitle>
						<div style={spinnerStyle}>
							<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
						</div>

					{:else if $authState === AuthState.LOGGING_IN_CHALLENGE}

						{#if $challengeType === AuthChallenge.NEW_PASSWORD_REQUIRED}

							<Subtitle>A new password is required.</Subtitle>

							<form id="login-newpassword-form" name="login-newpassword-form" url="/" autocomplete="on" on:submit={onLoginNewPasswordSubmit}>

								<Textfield type="password" dense variant={"filled"} bind:value={$loginPassword} input$autocomplete="off" label="New Password" style={style} on:keyup={onLoginNewPasswordValidate}/>

								{#if $loginError.length > 0}
									<div class="bg-error" style={errorStyle}>{@html $loginError}</div>
								{/if}

								{#if $loginSubmitting}
									<Button variant="unelevated" style={style} disabled={true}>
										<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
									</Button>
								{:else}
									<Button on:click={onLoginNewPasswordSubmit} variant="unelevated" style={style} disabled={$loginError.length > 0 || $loginPassword.length == 0}>
										<Label>Set New Password</Label>
									</Button>
								{/if}

							</form>

						{:else}

							<p>An error occured: {$challengeType}</p>

						{/if}

					{:else if $authState === AuthState.LOGGING_OUT}

						<Subtitle>Logging out...</Subtitle>
						<div style={spinnerStyle}>
							<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
						</div>

					{/if}

				{:else}

					<div class="bg-error" style={errorStyle}>An error occured. Please try again.</div>

				{/if}

			</Content>
		</Paper>
		